<template>
    <div class="mt-4 mb-2 ">
        <div class="layout row mb-2 ml-3">
            <div class="font-weight-medium mr-1 width-200">
                Date:
            </div>
            <div>{{ row.date | time }}</div>
        </div>

        <div class="layout row mb-2 ml-3" v-for="prop in getRowProperties()">
            <div class="font-weight-medium mr-1 width-200">
                {{ prop.name }}:
            </div>
            <div>{{ prop.value }}</div>
        </div>

        <vue-good-table
            class="schedule-detail-list"
            style="width: 92%; margin-left: 16px;"
            styleClass="vgt-table striped"
            :columns="scheduleDetailColumns"
            :rows="scheduleDetails"
            v-if="scheduleDetails && scheduleDetails.length"
            :search-options="{
                enabled: false,
            }"
        >
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.isIcon" class="px-0">
                    <v-icon
                        class="px-0"
                        dark
                        :color="
                            props.column.iconColor(
                                props.row[props.column.field]
                            )
                        "
                        >{{
                            props.column.icon(props.row[props.column.field])
                        }}</v-icon
                    >
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
    </div>
</template>
<script>
import moment from "moment";
import { toTitleCase, except, formatCurrency } from "../../utils/helpers.js";

export default {
    props: {
        row: Object,
        columns: Array,
        reloadGrid: Function,
    },
    data() {
        return {
            scheduleDetails: [],

            scheduleDetailColumns: [
                {
                    sortable: true,
                    field: "status",
                    hidden: false,
                    isIcon: true,
                    icon: (value, row) => {
                        if (!value) return "";

                        if (value.toUpperCase().startsWith("ERROR"))
                            return "mdi-alert-circle";

                        switch (value.toUpperCase()) {
                            case "APPROVED":
                                return "mdi-check-circle";
                            case "SCHEDULED":
                                return "mdi-clock";
                            case "DECLINED":
                                return "mdi-alert";
                            case "CANCELED":
                                return "mdi-close-circle";
                            default:
                                return "";
                        }
                    },
                    iconColor: (value, row) => {
                        if (!value) return "";

                        if (value.toUpperCase().startsWith("ERROR"))
                            return "#f35123";

                        switch (value.toUpperCase()) {
                            case "APPROVED":
                                return "success";
                            case "SCHEDULED":
                                return "#fdb400";
                            case "DECLINED":
                                return "#f35123";
                            case "CANCELED":
                                return "#aeb8bf";
                            default:
                                return "";
                        }
                    },
                },
                {
                    sortable: true,
                    label: "Date",
                    field: "scheduleDate",
                    hidden: false,
                    type: "date",
                    width: "100px",
                    dateOutputFormat: "MM/DD/YYYY",
                },
                {
                    sortable: true,
                    label: "Amount",
                    field: "amount",
                    type: "decimal",
                    width: "100px",
                    hidden: false,
                    formatFn: (value) => formatCurrency(value),
                },
                {
                    sortable: false,
                    label: "Details",
                    field: "details",
                    hidden: false,
                    width: "250px",
                    formatFn: (value) => {
                        if (!value) return "";

                        const categories = new Map([
                            ["TC", "Tuition"],
                            ["TRNS", "Transportation"],
                            ["LAPC", "Lapidus"],
                        ]);

                        return value
                            .split("|")
                            .map((detail) => {
                                const category =
                                    categories.get(detail.split(":")[0]) ||
                                    detail.split(":")[0];
                                const amount = detail.split(":")[1];

                                return category + ": " + formatCurrency(amount);
                            })
                            .sort()
                            .reverse()
                            .join(" | ");
                    },
                },
                {
                    sortable: false,
                    label: "Card",
                    field: "cardInfo",
                    width: "220px",
                    hidden: false,
                },
                {
                    sortable: true,
                    label: "Status",
                    field: "status",
                    width: "100px",
                    hidden: false,
                },
                {
                    sortable: false,
                    label: "Process Date",
                    field: "processDate",
                    type: "date",
                    width: "215px",
                    dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                    hidden: false,
                },
                {
                    label: "Attempts",
                    field: "attempts",
                    type: "number",
                    sortable: false,
                    width: "150px",
                    hidden: false,
                },
                {
                    sortable: false,
                    label: "Canceled At",
                    field: "cancelDate",
                    type: "date",
                    width: "215px",
                    dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                    hidden: false,
                },
                {
                    sortable: false,
                    label: "Canceled By",
                    field: "canceledBy",
                    width: "150px",
                    hidden: false,
                },
                {
                    sortable: false,
                    label: "Updated By",
                    field: "userUpdated",
                    width: "150px",
                    hidden: false,
                },
                {
                    sortable: false,
                    label: "Last Updated",
                    field: "lastUpdated",
                    type: "date",
                    width: "200px",
                    dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                    hidden: false,
                },
            ],
        };
    },
    async created() {
        this.loadScheduleDetails();
    },
    computed: {},
    methods: {
        getCategoryName(category) {
            return category == "TC"
                ? "Tuition"
                : category == "TRNS"
                ? "Transportation"
                : category;
        },
        getRefundDetails() {
            if (!this.row.refunds) return;

            return this.row.refunds.split("|").map((detail) => {
                const date = this.formatTime(detail.split(",")[0]);
                const amount = detail.split(",")[1];

                return {
                    date,
                    amount,
                };
            });
        },
        getRowProperties() {
            return Object.keys(
                except(
                    this.row,
                    "vgt_id",
                    "originalIndex",
                    "vgtExpended",
                    "userName",
                    "details",
                    "refunds",
                    "date",
                    "scheduleDetails",
                    "isImported",
                    "processedDate",
                    "dateCreated"
                )
            )
                .map((key) => {
                    const column = this.columns
                        .filter((c) => !c.isIcon)
                        .find((c) => c.field == key);

                    return {
                        name: column ? column.label : toTitleCase(key),
                        value: this.row[key],
                    };
                })
                .filter((p) => p.value);
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
        async loadScheduleDetails() {
            if (!this.row.scheduleID) return;

            const details = await this.$http.get(
                "api/schedules/getScheduleDetails?scheduleID=" +
                    this.row.scheduleID
            );

            this.scheduleDetails = details.map((detail) => {
                detail.cardInfo = detail.cardType + " - " + detail.cardNumLast5;

                return detail;
            });

            ["canceledBy", "cancelDate", "userUpdated", "lastUpdated"].forEach(
                (field) => {
                    if (details.some((detail) => detail[field])) {
                        this.scheduleDetailColumns.find(
                            (c) => c.field == field
                        ).hidden = false;
                    }
                }
            );
        },
    },
};
</script>
<style>
.schedule-detail-list .vgt-table {
    border: 1px solid #ddd !important;
}

.schedule-detail-list table.vgt-table td {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    padding-left: 8px !important;
    font-weight: 400 !important;
}

.schedule-detail-list tr:nth-child(even) {
    background-color: #fff !important;
}
</style>
